import { FormButtonInterface } from "components/forms/buttons";
import { faCaretLeft, faCaretRight } from "components/icon-library";

export const CancelButton: FormButtonInterface = {
  text: "Peruuta",
  align: "full",
  type: "secondary",
  onClick: async () => {},
  preIcon: faCaretLeft,
};

export const SubmitButton: FormButtonInterface = {
  text: "Tallenna",
  align: "full",
  type: "primary",
  postIcon: faCaretRight,
  submit: true,
};
